import {
  API_ERROR,
  SET_PARAMS,
  AUDIT_PURCHASE_ORDER_LIST,
  AUDIT_PURCHASE_ORDER_LIST_SUCCESS,
  OPEN_SCREEN,
  AUDIT_PURCHASE_ORDER,
  AUDIT_MIN_WINDOW,
  AUDIT_MAX_WINDOW,
  AUDIT_POP_RIGHT,
  AUDIT_PURCHASE_ORDER_ROW_DATA,
  AUDIT_PURCHASE_ORDER_ROW_DATA_SUCCESS,
  AUDIT_IGP_LIST_DATA,
  AUDIT_IGP_LIST_DATA_SUCCESS,
  AUDIT_IGP_ROW_DATA,
  AUDIT_IGP_ROW_DATA_SUCCESS,
  AUDIT_QUOTATION_ROW_DATA,
  AUDIT_QUOTATION_ROW_DATA_SUCCESS,
  AUDIT_RFQ_ROW_DATA,
  AUDIT_RFQ_ROW_DATA_SUCCESS,
  AUDIT_CQ_DATA,
  AUDIT_PI_ROW_DATA,
  AUDIT_PI_ROW_DATA_SUCCESS,
  AUDIT_MR_ROW_DATA,
  AUDIT_MR_ROW_DATA_SUCCESS,
  ITEM_AUDIT_APPROVAL,
} from "./actionTypes";

const initialState = {
  loading: false,
  AuditPOList: [],
  AuditPOListCount: 0,
  params: {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
  },
  CQId: null,
  AuditData: [],
  openScreen: {
    ScreenNo: 1,
  },
  PORowData: {},
  QRowData: {},
  RFQrowdata: {},
  PIreqRowData: {},
  mrRowData: {},
};

const AuditReport = (state = initialState, action) => {
  switch (action.type) {
    case AUDIT_PURCHASE_ORDER_LIST:
      state = {
        ...state,
        loading: true,
        AuditData: [],
      };
      break;
    case AUDIT_PURCHASE_ORDER_LIST_SUCCESS:
      var noofpages = Math.ceil(action.payload.count / state.params.page_size);
      state = {
        ...state,
        AuditPOListCount: action.payload.count,
        AuditPOList: action.payload.results,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
        loading: false,
        AuditData: [],
      };
      break;
    case SET_PARAMS:
      state = {
        ...state,
        params: action.payload,
      };
      break;
    case OPEN_SCREEN:
      state = {
        ...state,
        openScreen: action.payload,
      };
      break;
    case AUDIT_PURCHASE_ORDER:
      state = {
        ...state,
        loading: true,
        AuditData: [],
      };
      break;
    case AUDIT_PURCHASE_ORDER_ROW_DATA:
      state = {
        ...state,
        loading: true,
        AuditData: [],
      };
      break;
    case AUDIT_PURCHASE_ORDER_ROW_DATA_SUCCESS:
      // state.AuditData = state.AuditData.map((obj, i) => {
      //   if (i === state.AuditData.length - 1) {
      //     obj.loading = false;
      //     obj.data = action.payload;
      //   }
      //   return obj;
      // });

      state = {
        ...state,
        AuditData: [
          ...state.AuditData,
          {
            // loading: true,
            data: action.payload,
            maximize: true,
            screen: "PO",
          },
        ],

        loading: false,
      };
      break;
    case AUDIT_POP_RIGHT:
      var AuditData3 = state.AuditData.filter((obj, i) => {
        if (action.payload >= i) {
          return true;
        } else {
          return false;
        }
      });
      state = {
        ...state,
        loading: false,
        AuditData: AuditData3,
      };
      break;
    case AUDIT_MAX_WINDOW:
      var AuditData1 = state.AuditData.map((obj, i) => {
        if (i === action.payload) {
          obj.maximize = true;
        }
        return obj;
      });

      state = {
        ...state,
        loading: false,
        AuditData: AuditData1,
      };
      break;
    case AUDIT_MIN_WINDOW:
      var AuditData2 = state.AuditData.map((obj, i) => {
        if (i === action.payload) {
          obj.maximize = false;
        }
        return obj;
      });

      state = {
        ...state,
        loading: false,
        AuditData: AuditData2,
      };
      break;
    case AUDIT_IGP_LIST_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case AUDIT_IGP_LIST_DATA_SUCCESS:
      state = {
        ...state,
        loading: false,
        AuditData: [
          ...state.AuditData,
          {
            // loading: true,
            data: action.payload,
            maximize: true,
            screen: "IGPList",
          },
        ],
      };
      break;
    case AUDIT_IGP_ROW_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case AUDIT_IGP_ROW_DATA_SUCCESS:
      state = {
        ...state,
        AuditData: [
          ...state.AuditData,
          {
            // loading: true,
            data: action.payload,
            maximize: true,
            screen: "IGPView",
          },
        ],

        loading: false,
      };
      break;
    case AUDIT_QUOTATION_ROW_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case AUDIT_QUOTATION_ROW_DATA_SUCCESS:
      state = {
        ...state,
        AuditData: [
          ...state.AuditData,
          {
            // loading: true,
            data: action.payload,
            maximize: true,
            screen: "Q",
          },
        ],

        loading: false,
      };
      break;
    case AUDIT_RFQ_ROW_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case AUDIT_RFQ_ROW_DATA_SUCCESS:
      state = {
        ...state,
        AuditData: [
          ...state.AuditData,
          {
            // loading: true,
            data: action.payload,
            maximize: true,
            screen: "RFQ",
          },
        ],

        loading: false,
      };
      break;
    case AUDIT_CQ_DATA:
      state = {
        ...state,
        // loading: true,
        // CQId: action.payload,
        AuditData: [
          ...state.AuditData,
          {
            data: action.payload,
            maximize: true,
            screen: "CQ",
          },
        ],
      };
      break;

    case AUDIT_PI_ROW_DATA:
      state = {
        ...state,
        loading: true,
        openScreen: {
          ScreenNo: action.payload.ScreenNo,
        },
      };
      break;
    case AUDIT_PI_ROW_DATA_SUCCESS:
      state = {
        ...state,
        AuditData: [
          ...state.AuditData,
          {
            // loading: true,
            data: action.payload,
            maximize: true,
            screen: "PI",
          },
        ],
        loading: false,
      };
      break;
    case AUDIT_MR_ROW_DATA:
      state = {
        ...state,
        loading: true,
        openScreen: {
          ScreenNo: action.payload.ScreenNo,
        },
      };
      break;
    case AUDIT_MR_ROW_DATA_SUCCESS:
      var mr_approvals = [];
      mr_approvals = action.payload.mr_approvals.filter((approvale) => {
        if (approvale.mrstatus === 3) {
          return approvale.approvedby;
        }
        return 0;
      });
      state = {
        ...state,
        AuditData: [
          ...state.AuditData,
          {
            // loading: true,
            data: {
              ...action.payload,
              userDeptApprovedby: mr_approvals,
            },
            maximize: true,
            screen: "MR",
          },
        ],
        loading: false,
      };
      break;
    case ITEM_AUDIT_APPROVAL:
      state = {
        ...state,
        loading: true,
      };
      break;

    case API_ERROR:
      state = {
        ...state,
        loading: false,
        loginError: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }

  return state;
};
export default AuditReport;
